var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuSignup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fc3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35934",
    "data-name": "Group 35934",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39640",
    "data-name": "Path 39640",
    className: "cls-1",
    d: "M12,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22ZM12,4a8,8,0,1,0,8,8A8.009,8.009,0,0,0,12,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39641",
    "data-name": "Path 39641",
    className: "cls-1",
    d: "M12,14a4,4,0,1,1,4-4A4,4,0,0,1,12,14Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,12,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39642",
    "data-name": "Path 39642",
    className: "cls-1",
    d: "M17.834,19.855a1,1,0,0,1-.958-.714A3.019,3.019,0,0,0,14,17H10a2.982,2.982,0,0,0-2.873,2.137,1,1,0,0,1-1.915-.576A5,5,0,0,1,10,15h4a5,5,0,0,1,4.792,3.569,1,1,0,0,1-.959,1.287Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSignup);
export default __webpack_public_path__ + "static/media/menu-signup.dcd8ecc3573a77225791b837159ddf71.svg";
export { ForwardRef as ReactComponent };